/* Karchir — katman (çekmece / panel / menü) ile tarayıcı geçmişi uyumu
   (Tur 92, Batuhan'ın mobil şikâyeti):

   Sepet çekmecesi, mobil menü, arama, hızlı bakış, filtre çekmecesi gibi
   katmanlar tarayıcı geçmişine girmiyordu. Mobilde katman açıkken "geri"
   tuşu siteden çıkarıyor, "ileri" ile dönünce katman yarım kalıyordu;
   sayfa yenilenince sepet çekmecesi kayboluyordu.

   Çözüm:
   1. Bir katman açılınca history.pushState ile bir geçmiş kaydı eklenir.
      "Geri" o katmanı kapatır (popstate), siteden çıkarmaz.
   2. Katman kendi kapat düğmesiyle kapanırsa eklenen kayıt history.back()
      ile geri alınır (geçmişte çöp kalmaz).
   3. Sayfa yenilenince / ödemeden dönünce geçmiş kaydında katman varsa
      sepet çekmecesi (theme-drawer) yeniden açılır — mobilde de.
   4. bfcache'ten dönen sayfada (pageshow persisted) kayıt ile açık
      katmanlar uyumsuzsa katmanlar kapatılır.

   Katman tespiti: <dialog> öğelerinin ve mobil menü <details>'inin "open"
   özniteliği MutationObserver ile izlenir. Küçük açıklama balonları
   (cart-disclosure-tooltip gibi) katman sayılmaz. */
(function () {
  'use strict';
  var ANAHTAR = 'karchirKatman';
  var SAHIP = 'theme-drawer, dialog-component, quick-add-dialog, zoom-dialog, header-drawer';
  var MENU_ID = 'Details-menu-drawer-container';
  var yigin = [];          // açık katman kimlikleri, açılış sırasıyla
  var beklenenPop = 0;     // bizim tetiklediğimiz history.back() sayısı
  var ayriliyor = false;   // pagehide sonrası
  var tazeBelge = false;   // sayfa, kayıtta katman varken YENİDEN yüklendi

  function durum() {
    return history.state && typeof history.state === 'object' ? history.state : {};
  }
  function kayitli() {
    var d = durum();
    return Array.isArray(d[ANAHTAR]) ? d[ANAHTAR] : [];
  }
  function yaz(liste, degistir) {
    var d = Object.assign({}, durum());
    if (liste.length) d[ANAHTAR] = liste.slice(); else delete d[ANAHTAR];
    try { (degistir ? history.replaceState : history.pushState).call(history, d, ''); } catch (e) { /* boş */ }
  }

  /* Bir "open" değişen öğe katman mı, kimliği ne? */
  function katman(el) {
    if (!(el instanceof Element)) return null;
    if (el.tagName === 'DETAILS') return el.id === MENU_ID ? el : null;
    if (el.tagName !== 'DIALOG') return null;
    if (el.closest('cart-disclosure-tooltip, [data-karchir-katman-degil]')) return null;
    var sahip = el.closest(SAHIP);
    if (sahip) return sahip;
    return el.id ? el : null;
  }
  function kimlik(el) {
    if (!el.id) el.id = 'karchir-katman-' + Math.random().toString(36).slice(2, 8);
    return el.id;
  }
  function acikMi(el) {
    if (el.tagName === 'DETAILS' || el.tagName === 'DIALOG') return el.hasAttribute('open');
    var d = el.querySelector('dialog');
    return !!(d && d.hasAttribute('open'));
  }

  function kapat(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var sahip = el.closest(SAHIP) || el;
    if (typeof sahip.closeDialog === 'function') sahip.closeDialog();
    else if (sahip.tagName !== 'DIALOG' && typeof sahip.close === 'function') sahip.close();
    else {
      var d = el.tagName === 'DIALOG' ? el : el.querySelector('dialog');
      if (d && d.open) d.close();
    }
  }
  function ac(id) {
    var el = document.getElementById(id);
    if (!el || acikMi(el)) return;
    if (el.tagName === 'THEME-DRAWER' && typeof el.open === 'function') el.open();
  }

  /* Kapanış geri alımı KISA GECİKMEYLE yapılır: hızlı bakış kapanıp hemen
     ardından sepet çekmecesi açılınca (Horizon auto-open) history.back()
     ile pushState yarışıyordu; çekmecenin kaydı siliniyor, "geri" yine
     siteden çıkarıyordu. Gecikme içinde yeni katman açılırsa mevcut kayıt
     yeni katmana devredilir (replaceState), geri alma yapılmaz. */
  var bekleyenKapanis = null;

  function acildi(el) {
    var id = kimlik(el);
    if (yigin.indexOf(id) !== -1) return;
    yigin.push(id);
    if (bekleyenKapanis) {
      clearTimeout(bekleyenKapanis);
      bekleyenKapanis = null;
      yaz(yigin, true);
      return;
    }
    if (kayitli().indexOf(id) !== -1) return; // kayıt zaten var (yenileme / geri dönüş)
    yaz(yigin, false);
  }
  function kapandi(el) {
    var id = kimlik(el);
    var i = yigin.lastIndexOf(id);
    if (i === -1) return;
    yigin.splice(i, 1);
    if (ayriliyor || document.visibilityState === 'hidden') return;
    var k = kayitli();
    if (k.indexOf(id) === -1) return;
    if (bekleyenKapanis) clearTimeout(bekleyenKapanis);
    bekleyenKapanis = setTimeout(function () {
      bekleyenKapanis = null;
      if (ayriliyor) return;
      var k2 = kayitli();
      if (tazeBelge && k2.length === 1 && yigin.length === 0) {
        // Bu belge, katman kaydı üstünde yeniden yüklendi: geri gitmek
        // sayfayı baştan yükletir. Kaydı yerinde temizle.
        yaz([], true);
        return;
      }
      if (yigin.length === 0 && k2.length >= 1) {
        beklenenPop++;
        history.back();
      } else {
        yaz(yigin, true);
      }
    }, 150);
  }

  new MutationObserver(function (kayitlar) {
    for (var i = 0; i < kayitlar.length; i++) {
      var el = katman(kayitlar[i].target);
      if (!el) continue;
      if (kayitlar[i].target.hasAttribute('open')) acildi(el); else kapandi(el);
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['open'], subtree: true });

  window.addEventListener('popstate', function () {
    if (beklenenPop > 0) { beklenenPop--; return; }
    var hedef = kayitli();
    for (var i = yigin.length - 1; i >= 0; i--) {
      if (hedef.indexOf(yigin[i]) === -1) { var id = yigin[i]; yigin.splice(i, 1); kapat(id); }
    }
    for (var j = 0; j < hedef.length; j++) {
      if (yigin.indexOf(hedef[j]) === -1) ac(hedef[j]); // ileri: çekmeceyi geri getir
    }
  });

  window.addEventListener('pagehide', function () { ayriliyor = true; });
  window.addEventListener('pageshow', function (e) {
    ayriliyor = false;
    if (!e.persisted) return;
    // bfcache'ten dönüş: kayıtta olmayan açık katmanları kapat
    var hedef = kayitli();
    for (var i = yigin.length - 1; i >= 0; i--) {
      if (hedef.indexOf(yigin[i]) === -1) { var id = yigin[i]; yigin.splice(i, 1); kapat(id); }
    }
  });

  function basla() {
    var k = kayitli();
    tazeBelge = k.length > 0;
    // zaten açık olanlar (masaüstü yeniden basma, restore betiği)
    var acik = document.querySelectorAll('dialog[open], details#' + MENU_ID + '[open]');
    for (var i = 0; i < acik.length; i++) { var el = katman(acik[i]); if (el) acildi(el); }
    // kayıtta olup açık olmayan çekmeceleri geri getir (yenileme / ödemeden dönüş)
    for (var j = 0; j < k.length; j++) {
      (function (id) {
        var el = document.getElementById(id);
        if (!el || acikMi(el) || el.tagName !== 'THEME-DRAWER') return;
        customElements.whenDefined('theme-drawer').then(function () { setTimeout(function () { ac(id); }, 50); });
      })(k[j]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla); else basla();
})();
